import React from "react";
import {PieLossTable} from "../components/PieLossTable";

export function Relative({fullData}) {
	return(
		<PieLossTable data={fullData}/>
	);
}
